const initalState = {
  isActive:false,
  data:null
}

export default function reducer(state = initalState, action) {
  switch (action.type){
    case 'TOGGLE_MENU':{
      state = {
        ...state,
        isActive:action.payload.isActive,
      }
      break
    }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/store/reducers/menuReducer.js